import PlentyApiClient from "./base";

export const plentyCredentialsApi = {
  // Credentials management
  getCredentials: () => {
    return PlentyApiClient.get("/plenty/credentials/");
  },

  createCredential: (data) => {
    return PlentyApiClient.post("/plenty/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return PlentyApiClient.delete(`/plenty/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return PlentyApiClient.put(`/plenty/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return PlentyApiClient.post(
      `/plenty/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (data) => {
    return PlentyApiClient.post(`/plenty/credentials/test`, data);
  },
};
